import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FuseFullscreenComponent } from '@fuse/components/fullscreen/fullscreen.component';
import { CommonModule } from '@angular/common';
import { TooltipModule } from 'primeng/tooltip';

@NgModule({
  declarations: [FuseFullscreenComponent],
  imports: [MatButtonModule, MatIconModule, CommonModule, TooltipModule],
  exports: [FuseFullscreenComponent],
})
export class FuseFullscreenModule {}
